import { render, staticRenderFns } from "./SearchInputBox.vue?vue&type=template&id=97acee18&scoped=true"
import script from "./SearchInputBox.vue?vue&type=script&lang=js"
export * from "./SearchInputBox.vue?vue&type=script&lang=js"
import style0 from "./SearchInputBox.vue?vue&type=style&index=0&id=97acee18&prod&lang=css"
import style1 from "./SearchInputBox.vue?vue&type=style&index=1&id=97acee18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97acee18",
  null
  
)

export default component.exports